import { render, staticRenderFns } from "./ManufacturingList.vue?vue&type=template&id=7bc9d4d4&"
import script from "./ManufacturingList.vue?vue&type=script&lang=js&"
export * from "./ManufacturingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports